import { LineChart, Line, ResponsiveContainer, YAxis, Tooltip } from 'recharts'

/**
 * Cumulative-points sparkline. Draws on first render via Recharts default animation.
 *
 * Props: data ([{date, points}]), color, height
 */
export default function Sparkline({ data = [], color = '#3076E2', height = 36, animated = true }) {
  if (!data.length) {
    return <div className="text-brand-text-muted text-xs italic">No activity yet</div>
  }

  let cumulative = 0
  const cumData = data.map(d => {
    cumulative += d.points
    return { date: d.date, cumulative }
  })

  return (
    <div style={{ height }} className="w-full">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={cumData}>
          <YAxis hide domain={['dataMin', 'dataMax']} />
          <Tooltip
            contentStyle={{ background: '#272727', border: 'none', borderRadius: 6, fontSize: 11, color: 'white' }}
            labelStyle={{ color: '#B8B8B8' }}
            formatter={(value) => [`${value} pts`, 'Total']}
          />
          <Line
            type="monotone"
            dataKey="cumulative"
            stroke={color}
            strokeWidth={2}
            dot={false}
            isAnimationActive={animated}
            animationDuration={900}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  )
}
